module.exports = "/virtual-football/img/video/clubs/spain/valencia.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football/img/video/clubs/spain/valencia.png
// module id = 308
// module chunks = 6